<template>
    <Dialog
            :dismissableMask="true"
            :style="{ width: '35vw' }"
            :modal="true"
            :visible.sync="show"
            @hide="closeDialog"
            :contentStyle="{overflow: 'visible'}"
            :maximizable="true"

    >
        <template #header>
            <i style=" transform: scale(1.7); " class="pi pi-th-large"></i>
            <h1>הוספת הערה</h1>
        </template>

        <div class="p-pt-4 p-fluid p-grid">
            <div class="p-field p-col-12 p-md-6">
                <label>סוג </label>
                <Dropdown
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי סוג"
                        emptyFilterMessage=" לא נמצא שם נושא תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="newItem.subjectType"
                        :options="reportTypes"
                        placeholder="בחר סוג"
                        data-key="value"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>
                <!--                <InputText type="text" v-model="newItem.subjectType" autofocus/>-->
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label>נושא </label>

                <Dropdown
                        :disabled="selectedReportType &&
				 selectedReportType.value ===
		noteType"
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי נושא"
                        emptyFilterMessage=" לא נמצא שם נושא תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="newItem.subjectId"
                        :options="subjectFilter"
                        placeholder="בחר נושא"
                        data-key="id"
                        @input="updateSubject"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>
            </div>
            <div class="p-field p-col-12 p-md-12">
                <label>הערה </label>
                <Textarea
                        style="    width: 100%;"
                        autoResize="true"
                        class="p-inputtextarea p-inputtext p-component"
                        v-model="newItem.description"
                />
            </div>
        </div>

        <template #footer>
            <Button
                    label="ביטול"
                    icon="pi pi-times"
                    @click="closeDialog"
                    class="p-button-secondary"
            />
            <Button :disabled="!canSave" class="p-button-success" label="הוספה" icon="pi pi-check" @click="post"/>
        </template>
    </Dialog>
</template>

<script>

import {mapState} from "vuex";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"
const reportTypesConsts = [
    {
        value: BEHAVIORS_TYPE,
        hebrewName: "הליכות"
    },
    {
        value: TOPICS_TYPE,
        hebrewName: "מקצוע"
    },
    {
        value: PRESENCES_TYPE,
        hebrewName: "נוכחות"
    }, {
        value: NOTE_TYPE,
        hebrewName: "הערת מחנך"
    },
]
export default {
    name: "addDescriptionDialog",
    props: {
        show: Boolean,
    },
    data() {
        return {
            newItem: {},
            reportTypes: reportTypesConsts
        }
    },
    methods: {

        closeDialog() {
            this.$emit("closeDialog");
        },
        post() {
            const objToSave = {
                subjectId: this.newItem.subjectId.id,
                subjectType: this.newItem.subjectType.value,
                description: this.newItem.description,
                user: this.user.id
            }
            this.$emit("addItem", objToSave);
            this.$emit("closeDialog");
        },
    },
    computed: {
        canSave(){
          return this.newItem.subjectType && this.newItem.subjectId && this.newItem.description
        },
        subjectFilter() {
            if (this.newItem.subjectType?.value === TOPICS_TYPE) {
                return this.subjectTopicsFilter
            } else if (this.newItem.subjectType?.value === BEHAVIORS_TYPE) {
                return this.subjectTracingFilter
            } else if (this.newItem.subjectType?.value === PRESENCES_TYPE) {
                return this.presenceFilter
            }   else if (this.newItem.subjectType?.value  === NOTE_TYPE) {
                return [{id: "reportNote", hebrewName: "הערה"}]
            }
        },
        subjectTracingFilter() {
            return this.subjectTracing?.filter((subject) => subject?.reportActive === true)
        },
        subjectTopicsFilter() {
            return this.subjectLesson?.filter((subject) => subject?.reportActive === true)
        },
        presenceFilter() {
            return this.presenceStatus?.filter((subject) => subject?.reportActive === true)
        },
        ...mapState(["intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",
            "subjectTracing"]),
    },
}
</script>

<style scoped>

</style>